import React from 'react';
import classes from './Spotify.module.css';

const Spotify = () => {
  return (
    <div className={classes.spotify_container}>
      <iframe
        title="🎶Music is the wine 🥂 that fills the cup of silence.🤫"
        style={{
          borderRadius: '12px',
          backgroundColor: '#fff',
          border: '.15em solid rgb(217, 176, 255)',
          boxShadow:
            '0 0 1em .25em rgb(217, 176, 255),0 0 4em 1em rgba(191, 123, 255, 0.781),inset 0 0 .75em .25em rgb(217, 176, 255)'
        }}
        src="https://open.spotify.com/embed/playlist/1AMNYW1wrSLp5AeOH2W3Fb?utm_source=generator"
        width={'80%'}
        height={700}
        frameBorder={0}
        // allowFullScreen=""

        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      ></iframe>
    </div>
  );
};

export default Spotify;
